import React from "react";
import { useSelector } from "react-redux";

import * as HeaderModule from "@redux/modules/value/header/header.module";
import * as HeaderSelectors from "@redux/modules/value/header/header.selectors";
import * as ProfileSidebarModule from "@redux/modules/value/profileSidebar/profileSidebar.module";
import { useThunkDispatch } from "@redux/dispatcher";

import _Hamburger from "./hamburger.component";

const Hamburger = () => {
    const dispatch = useThunkDispatch();
    const header = useSelector(HeaderSelectors.getHeader);

    const update = (data: any) => {
        dispatch(HeaderModule.update(data));
    };

    const updateProfileSidebar = (data: any) => {
        dispatch(ProfileSidebarModule.update(data));
    };

    return (
        <_Hamburger
            active={!!header?.sidebarActive}
            handleClick={() => {
                update({ sidebarActive: !header?.sidebarActive });
                updateProfileSidebar({ active: false });
            }}
        />
    );
};

export { Hamburger };
